import { Divider, Stack } from '@mui/material';
import type { Condition, ResourceType } from '@repo/api-gw-sdk';

import type { FilterProperty } from '@/types/advanceFilter';

import { ResourceSelectionDynamicEditor } from './resourceSelectionDynamicEditor';
import type { ResourcesScopeType } from './resourceSelectionDynamicViewer';
import { ResourceSelectionManualOverridesEditor } from './resourceSelectionManualEditor';

export const ResourcesSelectionEditor = ({
  condition,
  setCondition,
  supportedProperties,
  conditionTitle,
  allExcludedDescription,
  allIncludedDescription,
  manualOverridesDescription,
  selectedResourceTypes,
  setSelectedResourceTypes,
  includedResources,
  excludedResources,
  setIncludedResources,
  setExcludedResources,
  resourcesScopeType,
  setResourcesScopeType,
  isEditable,
}: {
  condition?: Condition;
  setCondition: (condition?: Condition) => void;
  supportedProperties: FilterProperty[][];
  conditionTitle: React.ReactNode;
  allExcludedDescription: string;
  allIncludedDescription: string;
  manualOverridesDescription: string;
  resourcesScopeType: ResourcesScopeType;
  setResourcesScopeType: (resourcesScopeType: ResourcesScopeType) => void;
  includedResources: string[];
  excludedResources: string[];
  setIncludedResources: (includedResources: string[]) => void;
  setExcludedResources: (excludedResources: string[]) => void;
  selectedResourceTypes?: ResourceType[];
  setSelectedResourceTypes?: (resourceTypes: ResourceType[]) => void;
  isEditable?: boolean;
}) => {
  return (
    <Stack
      className='mx-[min(100px,5vw)] mt-[min(60px,3vw)]'
      flexGrow={1}
      minHeight={0}
      direction='row'
      gap='100px'
      justifyContent='space-between'
    >
      <ResourceSelectionDynamicEditor
        condition={condition}
        setCondition={setCondition}
        supportedProperties={supportedProperties}
        conditionTitle={conditionTitle}
        allExcludedDescription={allExcludedDescription}
        allIncludedDescription={allIncludedDescription}
        resourcesScopeType={resourcesScopeType}
        setResourcesScopeType={setResourcesScopeType}
        selectedResourceTypes={selectedResourceTypes}
        setSelectedResourceTypes={setSelectedResourceTypes}
        isEditable={isEditable}
      />
      <Stack direction='row' gap='100px'>
        <Divider orientation='vertical' flexItem />
        <ResourceSelectionManualOverridesEditor
          description={manualOverridesDescription}
          includeResources={includedResources ?? []}
          excludeResources={excludedResources ?? []}
          setIncludedResources={setIncludedResources}
          setExcludedResources={setExcludedResources}
        />
      </Stack>
    </Stack>
  );
};
